import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex: 1;
  align-content: center;
  justify-content: center;
  flex-direction: column;
`;

export const Activity = styled.div`
  margin-bottom: 20px;
  padding: 10px;
  background: rgba(61, 155, 233, 0.2);
  text-align: center;
  font-weight: bold;
  border-radius: 5px;
`;

export const ContainerSpotlight = styled.div`
  .current-activity-sidebar {
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
    align-content: center;
    justify-content: center;
  }

  .current-activity-sidebar___input {
    width: 100%;
    margin-bottom: 10px;
  }
`;
